import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, forwardRef, } from 'react';
import classNames from 'classnames';
import omit from 'lodash/fp/omit';
import { isDesktop } from '../../utils/deviceUtils';
import { PLACEMENT } from '../../values/Placement';
import { TEXT_ALIGNMENT } from '../../values/TextAlignment';
const STYLE_MAP = {
    STYLE_DEFAULT: 'default',
    STYLE_ONBOARDING: 'onboarding',
};
const TEXT_ALIGNMENT_MAP = {
    TEXT_ALIGNMENT_LEFT: TEXT_ALIGNMENT.LEFT,
    TEXT_ALIGNMENT_CENTER: TEXT_ALIGNMENT.CENTER,
    TEXT_ALIGNMENT_RIGHT: TEXT_ALIGNMENT.RIGHT,
};
const Tooltip = forwardRef((props, ref) => {
    const { allowOnTouch = false, arrowProps, children, className = '', innerClassName = '', placement = 'bottom', style, textAlignment = 'center', tooltipStyle = 'default', width = 'auto', ...remainingProps } = omit(['popper', 'positionLeft', 'positionTop'], props);
    // Mount the component but don't show it yet via CSS.
    // After it is mounted, we set the visibility class to use CSS animation
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => setIsMounted(true), []);
    if (!isDesktop() && !allowOnTouch) {
        // Workaround: we have to return a DOM node as otherwise the
        // react-transition library would throw an error on mobile
        // when triggering a browser reflow and accessing the node directly.
        return _jsx("span", { className: 'display-none' });
    }
    const wrapperClasses = classNames('tooltip', tooltipStyle && `tooltip-${tooltipStyle}`, placement, 'fade', isMounted && 'show', className);
    const innerClasses = classNames('tooltip-inner', textAlignment && `text-${textAlignment}`, width && `width-${width}`, innerClassName && innerClassName);
    /* eslint-disable react/no-unknown-property */
    return (_jsxs("div", { ...remainingProps, role: 'tooltip', "x-placement": placement, ref: ref, className: wrapperClasses, style: { ...style }, "data-offset": 20, children: [_jsx("div", { className: 'tooltip-arrow', ...arrowProps }), _jsx("div", { className: innerClasses, children: children })] }));
});
// statics
Object.assign(Tooltip, STYLE_MAP);
Object.assign(Tooltip, PLACEMENT); // is keyed as-is
Object.assign(Tooltip, TEXT_ALIGNMENT_MAP);
export default Tooltip;
